import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = "Keep Task",
  variant = "danger",
  onConfirm,
  onClose,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onConfirm, onClose]);

  if (!open) return null;

  const confirmClasses =
    variant === "danger"
      ? "bg-[#496D83] hover:opacity-90 text-white" // close to your screenshot color for Cancel
      : variant === "success"
      ? "bg-green-600 hover:bg-green-700 text-white"
      : "bg-gray-800 hover:bg-gray-900 text-white";

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Card */}
      <div className="relative z-[1000] w-[92%] sm:w-[520px] rounded-[12px] bg-white shadow-xl">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-start justify-between">
            <h3 className="text-[17px] font-inter font-semibold text-[#0A0A0A]">
              {title}
            </h3>
            <button
              onClick={onClose}
              className="text-[#475569] hover:text-black rounded-md focus:outline-none"
              aria-label="Close dialog"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>

          {/* Body */}
          <p className="mt-4 text-[14px] font-inter font-normal text-[#364153] text-left">
            {description}
          </p>

          {/* Footer */}
          <div className="mt-9 flex items-center justify-end gap-3">
            <button
              onClick={onClose}
              className="px-3 py-2 rounded-[10px] border border-[#D1D5DC] bg-white text-[#0A0A0A] text-xs font-inter font-medium"
            >
              {cancelLabel}
            </button>

            <button
              onClick={onConfirm}
              className={`px-4 py-2 rounded-[10px] text-sm bg-[#50869A] text-white`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
